import styled from 'styled-components';
import {Space} from 'antd';
import AntdModal from '../../../AntdModal';

const StyledEditInvoiceModal = styled(AntdModal)`
  .ant-modal-content > div.ant-modal-body {
    font-size: 16px;
    font-weight: 500;
    padding: 24px 40px;
  }
  p {
    color: ${props => props.theme.colors.neutral_10};
    font-size: 16px;
    font-weight: 500;
    margin: auto;
    max-width: 220px;
    padding: 0;
  }
`;

const StyledEditInvoiceModalSpace = styled(Space)`
  width: 100%;
  
  .ant-space-item {
    text-align: center;
    width: 100%;
  }
  
  .ant-space {
    width: 100%;
  }
`;

const StyledEditInvoiceModalLogoContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: auto;
  svg {
    height: 32px;
    width: 32px;
    path {
      fill: ${props => props.theme.colors.neutral_10};
    }
  }}
`;

export {
  StyledEditInvoiceModal,
  StyledEditInvoiceModalSpace,
  StyledEditInvoiceModalLogoContainer,
};
